import { 
    Chart as ChartJS, 
    ArcElement, 
    PieController, 
    BarController, 
    BarElement, 
    CategoryScale, 
    LinearScale, 
    LineElement,
    PointElement,
    Filler,
    Title, 
    Tooltip, 
    Legend 
} from 'chart.js';

ChartJS.register(
    ArcElement, 
    PieController, 
    BarController, 
    BarElement, 
    CategoryScale, 
    LinearScale, 
    LineElement,
    PointElement,
    Filler,
    Title, 
    Tooltip, 
    Legend
);